import React from 'react'
import { AuthProvider } from './auth-context'

export const AppProviders = ({ children }) => {
  return <AuthProvider>{children}</AuthProvider>
}
